/* Dependencies */
import styled from 'styled-components';

const TopBarItemContainer = styled.div.attrs(({ classname }: any) => ({
  className: classname
    ? `${classname} TopBarItemContainer`
    : 'TopBarItemContainer',
}))`
  display: flex;
  height: 100%;
  min-width: 40px;
  align-items: center;

  #TopBarUserAvatar,
  #TopBarOrganizationIcon {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 100%;
  }

  &#TopBarUserProfileSection {
    cursor: pointer;
  }

  #TopBarMaterialsIcon {
    margin-left: 2rem;
  }
`;

export default TopBarItemContainer;
